import window from 'window';

import { default as browserDetector } from 'browser-type-detector';

export const asyncCheckIfPlatformVerificationAvailable = async () => {
	if (window.PublicKeyCredential) {
		const isAvailable = await window.PublicKeyCredential
				.isUserVerifyingPlatformAuthenticatorAvailable();
		return isAvailable;
	}
	return false;
};

export const checkIfMobile = () => {
	return browserDetector.isIOS() || browserDetector.isAndroid();
};
